import Icon from '@ant-design/icons';
import React from "react";
import {ReactComponent as AccountIcon} from '../images/cloud/layout/nav_account.svg'
import {ReactComponent as CustomerTouchIcon} from '../images/cloud/layout/nav_customer_touch.svg'
import {ReactComponent as DrainageIcon} from '../images/cloud/layout/nav_drainage.svg'
import {ReactComponent as GroupChatIcon} from '../images/cloud/layout/nav_groupchat.svg'
import {ReactComponent as FriendIcon} from '../images/cloud/layout/nav_friend.svg'
import CloudPath from "../pages/cloud/cloud_path";

const CloudNavConfig = [
    {
        title: '账号运营',
        key: 'account',
        isOpen: 'true',
        icon: < Icon component={AccountIcon}/>,
        submenu: [
            {
                title: '账号管理',
                path: CloudPath.getSeatPath(),
                pathIn: CloudPath.isSeatPath
            },
            {
                title: '聚合聊天',
                path: CloudPath.getImChat(),
                pathIn: CloudPath.isImChat,
                link: true
            },
            {
                title: '话术库',
                path: CloudPath.getTalklibPath(),
                pathIn: CloudPath.isSeatTalklibPath
            }
        ]
    },
    {
        title: '拓客引流',
        key: 'drainage',
        isOpen: 'true',
        icon: < Icon component={DrainageIcon}/>,
        submenu: [
            {
                title: '手机号加好友',
                path: CloudPath.getMobileFriend(),
                pathIn: CloudPath.isMobileFriend
            },
            {
                title: '群加好友',
                path: CloudPath.getGroupChatFriend(),
                pathIn: CloudPath.isGroupChatFriend
            },
            {
                title: '接受新客户',
                path: CloudPath.newFriendRequest(),
                pathIn: CloudPath.isNewFriendRequest
            },
            // {
            //     title: '新客户运营',
            //     path: CloudPath.newFriendRemark(),
            //     pathIn: CloudPath.isNewFriendRemark
            // }
        ]
    },
    {
        title: '客户运营',
        key: 'friend',
        isOpen: 'true',
        icon: < Icon component={FriendIcon}/>,
        submenu: [
            {
                title: '客户管理',
                path: CloudPath.getCustOperationManageList(),
                pathIn: CloudPath.isCustOperationManagePath
            },
            {
                title: '新客户运营',
                path: CloudPath.newFriendRemark(),
                pathIn: CloudPath.isNewFriendRemark
            },
            {
                title: '单向好友',
                path: CloudPath.getOneWayFriendPath(),
                pathIn: CloudPath.isOneWayFriendPath
            },
        ]
    },
    {
        title: '客户触达',
        key: 'market',
        isOpen: 'true',
        icon: < Icon component={CustomerTouchIcon}
        />,
        submenu: [
            {
                title: '智能回复',
                path: CloudPath.getCloudKeyword(),
                pathIn: CloudPath.isCloudKeyword
            },
            // {
            //     title: '好友欢迎语',
            //     path: Path.getMarketGroupbuy(),
            //     pathIn: Path.isMarketGroupbuy
            // },
            {
                title: '消息群发',
                path: CloudPath.getCloudFriendGroupsend(),
                pathIn: CloudPath.isCloudFriendGroupsend
            },
            {
                title: '客户SOP',
                path: CloudPath.getCustomerSop(),
                pathIn: CloudPath.isCustomerSop
            },
            {
                title: '群聊SOP',
                path: CloudPath.getGroupSop(),
                pathIn: CloudPath.isGroupSop
            },
            {
                title: 'SOP模板',
                path: CloudPath.getCustomerSopTemplate(),
                pathIn: CloudPath.isCustomerSopTemplate
            }, {
                title: '素材库',
                path: CloudPath.getCustomerMaterial(),
                pathIn: CloudPath.isCustomerMaterial
            }
            // {
            //     title: '好友日历',
            //     path: Path.getMarketRedeemCode(),
            //     pathIn: Path.isMarketRedeemCode
            // }
        ]
    },
    {
        title: '高效社群',
        key: 'customer',
        isOpen: 'true',
        icon: < Icon component={GroupChatIcon}
        />,
        submenu: [
            {
                title: '群聊管理',
                path: CloudPath.getGroupChatManage(),
                pathIn: CloudPath.isGroupChatManage
            },
            {
                title: '群聊标签',
                path: CloudPath.getGroupChatTagList(),
                pathIn: CloudPath.isGroupChatTagList
            },
            {
                title: '入群欢迎语',
                path: CloudPath.getGroupChatRoomWelMsg(),
                pathIn: CloudPath.isGroupChatRoomWelMsg
            },
            {
                title: '群活码',
                path: CloudPath.getGroupChatLivecode(),
                pathIn: CloudPath.isGroupChatLivecode
            },
            {
                title: '群发公告',
                path: CloudPath.getGroupChatNotice(),
                pathIn: CloudPath.isGrouChatNotic
            },
            {
                title: '关键词拉群',
                path: CloudPath.getGroupChatKWPullGroup(),
                pathIn: CloudPath.isGroupChatKWPullGroup
            },
            // {
            //     title: '群聊日历',
            //     path: Path.gotoAssetSettle() + 1,
            //     pathIn: Path.isMarketAssetsSettle
            // },
            {
                title: '高级拉群',
                path: CloudPath.getAutoInvite(),
                pathIn: CloudPath.isAutoInvite
            },
            // {
            //     title: '通过好友拉群',
            //     path: Path.getMpConfig(),
            //     pathIn: Path.isMpConfig
            // },
            // {
            //     title: '多群转播',
            //     path: Path.getCorpManageConfig(),
            //     pathIn: Path.isCorpManageConfig
            // },
            {
                title: '群聊质检',
                path: CloudPath.getGroupChatCloudErrorCheck(),
                pathIn: CloudPath.isCloudGroupChatErrorCheck
            },
            {
                title: '黑名单',
                path: CloudPath.getBlackList(),
                pathIn: CloudPath.isBlackList
            },
            {
                title: '白名单',
                path: CloudPath.getWhiteList(),
                pathIn: CloudPath.isWhiteList
            },
        ]
    },
    // {
    //     title: '客户接待',
    //     key: 'customerReception',
    //     isOpen: 'true',
    //     icon: < Icon component={ImChatIcon}/>,
    //     submenu: [
    //         {
    //             title: '在线聊天',
    //             path: CloudPath.getImChat(),
    //             pathIn: CloudPath.isImChat,
    //             link: true
    //         }
    //     ]
    // }
];

export default CloudNavConfig